import { useState } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { Button, Alert } from '@mui/material';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import { isUnreadablePhoto } from '../../photoFiles';

export default function PhotoCapture({ label, multiple = false, onFiles }) {
  const { t } = useTranslation();
  const [bad, setBad] = useState(false);
  return (
    <>
      <Button variant='contained' size='large' component='label' startIcon={<PhotoCameraIcon />}>
        {label || t('calendar.invoice.takePhoto')}
        <input hidden type='file' accept='image/jpeg,image/png' capture='environment' multiple={multiple}
          onChange={e => {
            const files = [...e.target.files];
            e.target.value = '';
            if (files.some(isUnreadablePhoto)) { setBad(true); return; }
            setBad(false);
            if (files.length) onFiles(files);
          }} />
      </Button>
      {bad && <Alert severity='error'><Trans i18nKey='photoUpload.unreadablePhoto' components={{ b: <b /> }} /></Alert>}
    </>
  );
}
